export default __webpack_public_path__ + "static/media/rakuten-vertical.19055042.webp";